module.exports = __webpack_public_path__ + "static/ca-919d14f97f086718da7172bd4f4fec03.jpg";